export class FullTextSearch{

  constructor(){}

  public tokenize(text:string, locale: string): Array<any>{
    const words = [];
    for (let segment of text.split(/ |,/i)){
      if (segment !== ''){
        words.push(segment.toLowerCase());
      }
    }
    return words;
  }

  public search(index: any, query: string, locale, callback) {
    const results = [];

    const terms = this.tokenize(query, locale);
    if (terms.length === 0)
      throw new Error('Keine Suchergebnisse');

    let expect = 0;
    const requests = terms.map(term => index.openKeyCursor(IDBKeyRange.bound(term, term + 'uffff'), 'prev'));
    requests.forEach(request => {
      ++expect;
      request.onsuccess = () => {
        if (--expect === 0)
          barrier();
      };
    });
    function barrier() {
      const cursors = requests.map(r => r.result);
      if (this.contains(null, cursors)) {
        callback(results);
        return;
      }

      cursors.sort((a, b) => indexedDB.cmp(a.primaryKey, b.primaryKey));
      if (indexedDB.cmp(cursors[0].primaryKey, cursors[cursors.length - 1].primaryKey) === 0) {
        results.push(cursors[0].primaryKey);
        expect = cursors.length;
        cursors.forEach(cursor => cursor.continue());
      } else {
        expect = 1;
        cursors[0].continue();
      }
    }

    function contains(a, obj) {
      for (var i = 0; i < a.length; i++) {
        if (a[i] === obj) {
          return true;
        }
      }
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/rcs-connector-index-db/fulltextsearch.ts